export const localConfig = {
  env: import.meta.env.REACT_APP_ENV,

  timeout: import.meta.env.REACT_APP_TIMEOUT,

  LEAD_MANAGEMENT_BASE: import.meta.env.REACT_APP_LEAD_MANAGEMENT_BASE,
  OEM_DASHBOARD_BASE: import.meta.env.REACT_APP_OEM_DASHBOARD_BASE,
  AUTH_SERVICE_BASE: import.meta.env.REACT_APP_AUTH_SERVICE_URL,
  LOCATION_SERVICE_BASE: import.meta.env.REACT_APP_LOCATION_SERVICE_URL,

  FIREBASE_API_KEY: import.meta.env.REACT_APP_KENECT_UI_FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: import.meta.env
    .REACT_APP_KENECT_UI_FIREBASE_AUTH_DOMAIN,
  FIREBASE_DATABASE_URL: import.meta.env
    .REACT_APP_KENECT_UI_FIREBASE_DATABASE_URL,
  FIREBASE_PROJECT_ID: import.meta.env.REACT_APP_KENECT_UI_FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: import.meta.env
    .REACT_APP_KENECT_UI_FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGE_SENDER_ID: import.meta.env
    .REACT_APP_KENECT_UI_FIREBASE_MESSAGE_SENDER_ID,
  FIREBASE_APP_ID: import.meta.env.REACT_APP_KENECT_UI_FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID: import.meta.env
    .REACT_APP_KENECT_UI_FIREBASE_MEASUREMENT_ID,
}

class NetworkConfig {
  constructor() {
    this.config = {}
  }

  setConfig = (config) => {
    this.config = config
  }

  getConfig = () => {
    return this.config
  }

  check = () => {
    if (!this.config.env) {
      throw new Error('No environment set.')
    }
  }
}

export const networkConfig = new NetworkConfig()
export default networkConfig.getConfig
